var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center pt-20 md:pt-32"},[_c('EmptyStateSVG'),_c('p',{staticClass:"text-zt-primary-200 text-zt-lg text-base leading-5 pt-4 font-normal text-center"},[_vm._v(_vm._s(_vm.$t("message.homeComponent.noForm")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }